import axios from "axios";

const serverUri =
  process.env.NODE_ENV == "production"
    ? 'https://api.lucien.ai'
    : "http://localhost:3000";

function extendUnique(validator) {
  validator.extend("unique", {
    lazy: true,
    getMessage: (field) => {
        if(field === "Numéro de sécurité sociale") {
            return "Ce numéro de sécurité sociale est déjà enregistré.";
        } else {
            return "Cet " +
            field.toLowerCase() +
            " est déjà enregistrée. Cette opération est limitée à une seule participation par foyer"
        }
    },
    async validate(value, [field, _id]) {
      try {
        const { data } = await axios.post(serverUri + "/api/check/" + _id, {
          operationId: _id,
          [field]: value,
        });

        if (data.status == "OK") {
          return false;
        } else {
          return true;
        }
      } catch (err) {
        return false;
      }
    },
  });
}

export default extendUnique;
